<template>
  <!-- 报警列表 -->
  <a-row :bordered="false">
    <a-row>
      <a-col :md="5" :sm="24" style="margin-right: 20px">
        <a-card style="height: 700px">
          <div slot="title" class="cardTitle">泵房设备</div>
          <div class="box">
            <a-tree
              v-if="zoneTreeData.length"
              :defaultExpandAll="true"
              :auto-expand-parent="false"
              :replace-fields="{ title: 'pumpName', key: 'id', value: 'id', selectable: 'selectable' }"
              :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
              :tree-data="zoneTreeData"
              @select="onSelect"
            />
          </div>
        </a-card>
      </a-col>
      <a-col :md="18" :sm="24">
        <a-card>
          <a-form layout="inline">
            <a-row :gutter="24">
              <a-col style="margin-bottom: 12px">
                <a-form-item label="设备编码">
                  <a-input v-model="query.flowMeterNo" placeholder="请输入设备编码" allow-clear />
                </a-form-item>

                <a-form-item label="报警级别">
                  <a-select placeholder="请选择报警级别" v-model="query.alarmLevel" style="width: 120px" allow-clear>
                    <a-select-option value="报警"> 报警 </a-select-option>
                    <a-select-option value="预警"> 预警 </a-select-option>
                  </a-select>
                </a-form-item>

                <a-form-item label="处理状态">
                  <a-select placeholder="请选择处理状态" v-model="query.isDispose" style="width: 120px" allow-clear>
                    <a-select-option :value="0"> 未处理 </a-select-option>
                    <a-select-option :value="1"> 已处理 </a-select-option>
                    <a-select-option :value="2"> 已忽略 </a-select-option>
                  </a-select>
                </a-form-item>

                <a-form-item style="margin-left: 12px">
                  <a-button type="primary" @click="queryList">查询</a-button>
                  <a-button style="margin-left: 12px" @click="resetList">重置</a-button>
                  <a-button type="danger" style="margin-left: 12px" @click="deleteSelectRow()">删除</a-button>
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>
          <a-table
            size="middle"
            rowKey="id"
            bordered
            :scroll="{ x: 1700 }"
            :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
            :data-source="list"
            :columns="columns"
            :loading="dataListLoading"
            :pagination="pagination"
            @change="pageChange"
          >
            <span slot="isDispose" slot-scope="text">
              <a-tag color="rgb(255, 99, 71)" v-if="text == 0"> 未处理 </a-tag>
              <a-tag color="rgb(50, 205, 50)" v-else-if="text == 1"> 已处理 </a-tag>
              <a-tag color="#1890ff" v-else> 已忽略 </a-tag>
            </span>
            <span slot="alarmLevel" slot-scope="text">
              <a-tag color="rgb(255, 0, 0)" v-if="text == '报警'"> 报警 </a-tag>
              <a-tag color="rgb(255, 165, 0)" v-else-if="text == '预警'"> 预警 </a-tag>
            </span>

            <span slot="action" slot-scope="text, record">
              <a :disabled="record.isDispose !== 0" @click="PublishTask(record.id)">处理</a>
              <a :disabled="record.isDispose !== 0" @click="LoseSightOf(record.id)" style="margin-left: 10px">忽略</a>
              <!-- <a @click="PublishTask(record.id)" v-if="record.isDispose !== 1">处理</a>
              <a style="margin-left: 12px" v-if="record.isDispose !== 2" @click="LoseSightOf(record.id)">忽略</a> -->
            </span>
          </a-table>
        </a-card>
      </a-col>
    </a-row>
    <!-- 新增 修改 的弹框 -->

    <task-modal ref="TaskModal" v-on:abc="update"></task-modal>
  </a-row>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import TaskModal from '../Secondary-water/TaskManagement/modules/TaskModal.vue'
const columns = [
  {
    title: '序号',
    dataIndex: '',
    key: 'rowIndex',
    width: 70,
    customRender: function (t, r, index) {
      return parseInt(index) + 1
    },
  },
  //   {
  //   title: '泵房编号',
  //   width: 100,
  //   dataIndex: 'flowMeterNo',
  // },
  {
    title: '设备编号',
    width: 150,
    dataIndex: 'flowMeterNo',
  },
  {
    title: '报警位置',
    width: 150,
    dataIndex: 'msgAddress',
    ellipsis: true,
  },
  {
    title: '报警级别',
    width: 100,
    dataIndex: 'alarmLevel',
    scopedSlots: { customRender: 'alarmLevel' },
  },
  {
    title: '处理状态',
    width: 80,
    dataIndex: 'isDispose',
    scopedSlots: { customRender: 'isDispose' },
  },

  {
    title: '开始报警时间',
    width: 150,
    dataIndex: 'createTime',
  },
  {
    title: '最近一次报警时间',
    width: 150,
    dataIndex: 'updateTime',
  },
  {
    title: '报警类型',
    width: 100,
    dataIndex: 'alarmType',
    // scopedSlots: { customRender: 'type'},
  },
  {
    title: '报警指标',
    width: 100,
    dataIndex: 'alarmIndex',
    align: 'alarmIndex',
  },
  {
    title: '指标当前报警值',
    width: 180,
    dataIndex: 'prewarningValue',
    ellipsis: true,
  },
  {
    title: '参考值',
    width: 100,
    dataIndex: 'refValue',
    ellipsis: true,
  },
  {
    title: '报警次数',
    width: 100,
    dataIndex: 'num',
  },
  {
    title: 'X坐标',
    width: 100,
    dataIndex: 'longitude',
    ellipsis: true,
  },
  {
    title: 'Y坐标',
    width: 100,
    dataIndex: 'latitude',
    ellipsis: true,
  },
  {
    title: '处理人',
    width: 100,
    dataIndex: 'disposeName',
    ellipsis: true,
  },
  {
    title: '处理时间',
    width: 150,
    dataIndex: 'disposeTime',
  },
  {
    title: '操作',
    width: '150px',
    dataIndex: 'action',
    fixed: 'right',
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  components: {
    TaskModal,
  },
  mixins: [mixinViewModule],
  name: 'task',
  data() {
    return {
      queryUrl: '/pipe-network/remote_water_meter_alarm_messages/page', //列表请求数据接口
      addOrUpdateUrl: '/pipe-network/water_works_malfunctions', //新增
      queryOneUrl: '/pipe-network/remote_water_meter_alarm_messages/', //查询单条地址
      deleteUrl: '/pipe-network/remote_water_meter_alarm_messages', //删除
      staffTreeData: [], // 分区数据选项
      bookTreeData: [], // 分区数据选项
      zoneTreeData: [], // 泵房选项
      query: {
        flowMeterNo: '',
        processor: '',
        alarmLevel: '',
        isDispose: 0,
        sysTab: 5,
      }, // 查询参数
      addOrUpdateVisible: false, // 新增修改是否可见
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }), //新增 修改
      titih: '新增',
      userlist: [],
      currentId: '',
      addOrUpdateFormh: {
        // disposeName: '',
        // alarmContent: '',
        isDispose: '',
        id: '',
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      columns,
    }
  },
  computed: {
    rules() {
      return {
        disposeName: [{ required: true, message: '请输入处理人', trigger: 'change' }],
        alarmContent: [{ required: true, message: '请输入报警描述', trigger: 'change' }],
        isDispose: [{ required: true, message: '请选择处理结果', trigger: 'change' }],
      }
    },
  },
  created() {
    this.queryList()
    this.getUserList()
    this.i()
  },
  methods: {
    resetList() {
      if (this.query.sysType) {
        let params = {
          sysType: this.query.sysType,
        }
        this.query = params
      } else {
        this.query = {
          flowMeterNo: '',
          processor: '',
          alarmLevel: '',
          isDispose: 0,
          sysTab: 5,
        }
      }

      this.pagination.current = 1
      this.selectedRows = []
      this.queryList()
    },
    i() {
      this.$http.get('/pipe-network/twice_water_pumps/list').then((res) => {
        this.zoneTreeData = res.data
      })
    },
    onSelect(selectedKeys, info) {
      console.log('onSelect', selectedKeys, info)
      this.selectedKeys = selectedKeys
      this.query.deviceName = selectedKeys[0]
      this.queryList()
    },
    // 根据id 修改
    handleCancel() {
      this.addOrUpdateVisible = false
      this.queryList()
      this.$refs.addOrUpdateFormh.resetFields()
    },
    addOrUpdateHandle(id) {
      this.addOrUpdateFormh.id = id
      this.titih = '编辑'
      this.addOrUpdateVisible = true
      this.isUpdate = false
      this.currentId = id
      this.addOrUpdateForm.resetFields()
      this.RightData = []
      if (id) {
        this.isUpdate = true
        this.$http
          .get(`${this.queryOneUrl}/${this.currentId}`)
          .then(({ data }) => {
            this.addOrUpdateForm.setFieldsValue(data)
          })
          .catch(() => {})
      }
    },
    getUserList() {
      this.$http.get('/pipe-network/water_works_devices/list').then(({ data }) => {
        
        let list = []
        data.map((item) => {
          console.log(item)
          list.push({
            title: item.deviceName,
            key: item.id,
            name: item.deviceName,
          })
        })
        this.userlist = list
      })
    },
    LoseSightOf(id) {
      let params = {
        id: id,
        isDispose: 2,
      }
      console.log(id, 'ddd')
      this.$confirm({
        title: '忽略',
        content: `您确定要忽略此条数据吗？`,
        centered: true,
        onOk: () => {
          this.$http.put('/pipe-network/remote_water_meter_alarm_messages', params).then((res) => {
            this.queryList()
            this.$message.success(`忽略此条数据成功！`)
          })
        },
      })
    },
    PublishTask(id) {
      this.currentId = id
      this.$refs.TaskModal.edit()
    },
    update(childValue) {
      console.log(childValue, 'ooo')
      if (childValue == 1) {
        let params = {
          id: this.currentId,
          isDispose: 1,
        }
        this.$http.put('/pipe-network/remote_water_meter_alarm_messages', params).then(({ data }) => {
          this.queryList()
        })
      }
    },
  },
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
.cardTitle {
  font-family: MicrosoftYaHeiSemibold;
  font-size: 18px;
  color: #333333;
  letter-spacing: 0.71px;
  font-weight: 600;
}
.box {
  height: 600px;
  width: 100%;
  overflow: auto;
  // 滚动条整体部分
  &::-webkit-scrollbar {
    width: 0px; //对垂直方向滚动条
    height: 0px; //对水平方向滚动条
  }
  //滚动的滑块
  &::-webkit-scrollbar-thumb {
    border-radius: 3px;
    background-color: #ccc//滚动条的颜色;
  }
  //内层滚动槽
  &::-webkit-scrollbar-track-piece {
    background-color: #ccc;
  }
}
/deep/ .ant-table-thead > tr > th > {
  text-align: center;
}

/deep/ .ant-table-tbody > tr > td {
  text-align: center;
}
</style>
